import { createReducer, on } from '@ngrx/store';
import { DEFAULT_SUBMISSION_HEADER_STATE } from '../constants';
import { SUBMISSION_HEADER_ACTIONS } from '../actions/submissions.actions';
import { SubmissionHeaderState } from '../types';

export const SUBMISSION_HEADER_REDUCER = createReducer<SubmissionHeaderState>(
  DEFAULT_SUBMISSION_HEADER_STATE,
  on(SUBMISSION_HEADER_ACTIONS.updateIRBPlusSuccess, (state, { irbState }) => ({
    ...state,
    irbState,
  })),
);
